<template>
    <div class="first-wrap">
        <div class="el-loading-mask is-fullscreen" style="">
            <div class="el-loading-spinner">
                <svg viewBox="25 25 50 50" class="circular">
                    <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
                </svg><!---->
            </div>
        </div>
        <z-lazyImg class="bg" :placeImg="bg_small" :src="bg" :mask="true"></z-lazyImg>
    </div>
</template>

<script>
    import bg_small from "src/assets/image/bg-place.png"
    import bg from "src/assets/image/bg2.jpg"

    export default {
        data(){
            return {
                bg,bg_small,
            }
        },
        computed:{
            token(){
                return this.$route.query.token;
            },
        },
        created(){
            this.Judge();
        },
        methods:{
            Judge(){
                this.$router.replace({
                    name:'login'
                })

                // ***下面暂时注释
                // if(this.token){
                //     let url = `api/saas/user/login`;
                //     this.$http.post(url,{
                //         once_token:this.token
                //     })
                //     .then(res=>{
                //         if(res.status == 200){
                //             switch(res.res_data.code){
                //                 case 0:
                //                 var loginTime = new Date().getTime();
                //                 sessionStorage.loginTime = loginTime;
                //                 this.$func.getUserInfo(true,info=>{
                //                     this.$router.replace({ name: 'dashboard' });
                //                     this.successTip("登录成功");
                //                 })
                //                 break;
                //             }
                //         }
                //     })

                // }else{
                //     this.$router.replace({
                //         name:'login'
                //     })
                // }
            }
        }
        
    }
</script>

<style lang="less">
    //首屏 
    .first-wrap{
        height:100%;
        width:100%;
        .bg{
            width: 100%;
            height: 100%;
            position: relative;
            &:after{
                content:"";
                display: block;
                position: absolute;
                top:0;
                left: 0;
                height: 100%;
                width: 100%;
                background: rgba(0,0,0,.6);
            }
        }

        // 等待层
        .el-loading-mask{
            background:rgba(0,0,0,0);
        }
    }
</style>



// WEBPACK FOOTER //
// home-wait.vue?5112df6a